import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { ListClientPaginationStateModel, LIST_CLIENT_PAGINATION_INITIAL_STATE } from '../../../../../../common/models';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { AllocationViewFilterProfileModel } from '../../models';
import {
  AllocationViewFilterProfileListInitialState,
  AllocationViewFilterProfileListLoad,
} from './allocation-view-filter-profile-list.actions';
import { AllocationViewFilterProfileListService } from './allocation-view-filter-profile-list.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type AllocationViewFilterProfileListStateModel =
  ListClientPaginationStateModel<AllocationViewFilterProfileModel>;

const initialState: AllocationViewFilterProfileListStateModel = LIST_CLIENT_PAGINATION_INITIAL_STATE;

@State<AllocationViewFilterProfileListStateModel>({
  name: 'allocationViewFilterProfileList',
  defaults: initialState,
})
@Injectable()
export class AllocationViewFilterProfileListState {
  constructor(
    private allocationViewFilterProfileListService: AllocationViewFilterProfileListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: AllocationViewFilterProfileListStateModel): AllocationViewFilterProfileListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: AllocationViewFilterProfileListStateModel): AllocationViewFilterProfileModel[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: AllocationViewFilterProfileListStateModel): boolean {
    return state.loaded;
  }

  @Action(AllocationViewFilterProfileListLoad)
  getProfileList(
    ctx: StateContext<AllocationViewFilterProfileListStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewFilterProfileListService.getAllocationViewFilterProfiles().pipe(
      take(1),
      map((items: AllocationViewFilterProfileModel[]) => {
        ctx.patchState({ items, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewFilterProfileListInitialState)
  setInitialState(ctx: StateContext<AllocationViewFilterProfileListStateModel>): void {
    ctx.setState(initialState);
  }
}
